import Canvas from "../../Components/Canvas/Canvas";
import "../../App.css";
import ExperienceTimeline from "./ExperienceTimeline";

function Experience() {
  return (
    <div className="container-root-projects" id="experience">
      <Canvas />
      <ExperienceTimeline />
    </div>
  );
}

export default Experience;